import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost, axiosPut, axiosPatch } from './axiosUtils';
import './axiosInterceptor';

const RewardService = {
  async getRewardList(): AxiosUtilsType {
    return await axiosGet(`reward/list`);
  },

  async createReward(reward: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`reward/create`, reward);
  },

  async getRewardDetails(selectedRowId: string): AxiosUtilsType {
    return await axiosGet(`reward/list/${selectedRowId}`);
  },

  async updateReward(selectedRowId: string, reward: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`reward/list/${selectedRowId}`, reward);
  },

  async deleteReward(selectedRowId: string): AxiosUtilsType {
    return await axiosPatch(`reward/list/${selectedRowId}`);
  },
};
export default RewardService;
